// Imported dynamically on purpose: `bitmap2vector` pulls in jimp and pngjs, roughly 1 MB
// uncompressed, and is only needed once a bitmap is actually converted. A static import here
// would put all of it in the entry chunk that every visitor downloads.
export async function convertBitmapToSvg(data: string): Promise<string> {
  const { bitmap2vector } = await import(/* webpackChunkName: "bitmap2vector" */ 'bitmap2vector');
  const results = await bitmap2vector({ input: data, linefilter: true });

  return results.content;
}
